export default "__VITE_ASSET__MJ7dgeJd__"